import MapUtils from "services/map/utils";
import MapActionTypes from "services/map/types";
import IndicatorsActioner from "services/indicators/actioner";

const IndicatorsMiddleware =
  ({ dispatch, getState }) =>
  (next) =>
  (action) => {
    if (typeof action === "function") {
      return action(dispatch, getState);
    }
    if (action.type === MapActionTypes.SET_CONFIG) {
      next(action);
      dispatch(
        IndicatorsActioner.setConfigParam(
          "tiles_url",
          MapUtils.getIndicatorsTilesUrl(getState().Map)
        )
      );
      return;
    }

    return next(action);
  };

export default IndicatorsMiddleware;
